import { useCallback, useMemo } from "react";

import { parseISO } from "date-fns";

import { usePagination } from "hooks";
import useRequest from "hooks/useRequest";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useQueryClientMeetings(clientId) {
  const memoizedClientId = useMemo(() => {
    return clientId;
  }, [clientId]);

  const queryFactory = useCallback(() => {
    const query = `query getClientMeetings($clientId: ID!, $pageSize: Int, $after: String) {
                    client(id: $clientId) {
                      events(first: $pageSize, after: $after) {
                        edges {
                          node {
                            id
                            name
                            externalId
                            startDate
                            endDate
                            crmState
                            meetingDateTypeId {
                                id
                                name
                            }
                            attendees {
                                edges {
                                    node {
                                      id
                                      name
                                    }
                                }
                            }
                          }
                        }
                        totalCount
                        pageInfo {
                          endCursor
                          hasNextPage
                        }
                      }
                    }
                  }`;

    const resolver = ({ data }) => {
      return {
        data: data.client.events.edges.map(({ node }) => {
          return {
            ...node,
            clientId: memoizedClientId,
            startDate: parseISO(node.startDate),
            endDate: parseISO(node.endDate),
            type: node.meetingDateTypeId,
            attendees: node.attendees.edges.map(({ node: attendeeNode }) => {
              return attendeeNode;
            }),
          };
        }),
        totalCount: data.client.events.totalCount,
        pageInfo: data.client.events.pageInfo,
      };
    };

    return { query, resolver };
  }, [memoizedClientId]);

  const { req } = useRequest(queryFactory);

  return usePagination(req, {
    variables: useMemo(() => {
      return { clientId: toGlobalId("Client", clientId) };
    }, [clientId]),
    options: {
      pageSizes: [5, 10, 30],
    },
  });
}

export default useQueryClientMeetings;
